'use client';

import * as React from 'react';
import { cn } from '../lib/utils.js';

export interface DisplayFieldProps extends React.HTMLAttributes<HTMLDivElement> {}

const DisplayField = React.forwardRef<HTMLDivElement, DisplayFieldProps>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cn('ed-display-field', className)} {...props}>
      {children}
    </div>
  ),
);
DisplayField.displayName = 'DisplayField';

export { DisplayField };
